export const LANGUAGE_GROUP_ARABIC = "arabic";
export const LANGUAGE_GROUP_DANISH = "danish";
export const LANGUAGE_GROUP_ENGLISH = "english";
export const LANGUAGE_GROUP_GERMAN = "german";
export const LANGUAGE_GROUP_GREENLANDIC = "greenlandic";
export const LANGUAGE_GROUP_FRENCH = "french";
export const LANGUAGE_GROUP_SPANISH = "spanish";
export const LANGUAGE_GROUP_TURKISH = "turkish";
export const LANGUAGE_GROUP_RUSSIAN = "russian";
export const LANGUAGE_GROUP_SWEDISH = "swedish";

export const GENDERED_LANGUAGES = [
  LANGUAGE_GROUP_FRENCH,
  LANGUAGE_GROUP_GERMAN,
  LANGUAGE_GROUP_SPANISH
];

export const LANGUAGE_GROUPS_PRIORITIZED = [
  LANGUAGE_GROUP_DANISH,
  LANGUAGE_GROUP_ENGLISH,
  LANGUAGE_GROUP_GERMAN,
  LANGUAGE_GROUP_FRENCH,
  LANGUAGE_GROUP_SPANISH,
  LANGUAGE_GROUP_GREENLANDIC,
  LANGUAGE_GROUP_ARABIC,
  LANGUAGE_GROUP_TURKISH,
  LANGUAGE_GROUP_RUSSIAN,
  LANGUAGE_GROUP_SWEDISH
];
